import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Id, PolicyRule } from 'src/types'

import { ApplicationState } from '../store'
import { getPolicy } from '../store/ducks/me/actions'

function useReasonPolicyRule(reason_id: Id): PolicyRule {
  const {
    me: { loading, policy }
  } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))
  const dispatch = useDispatch()

  useEffect(() => {
    if (loading.policy === undefined && !policy) {
      dispatch(getPolicy())
    }
  }, [dispatch, loading.policy, policy])

  const policyRule = useMemo<PolicyRule>(
    () => policy?.policy_rules.find(item => +item.reason_id === +reason_id),
    [policy, reason_id]
  )

  return policyRule
}

export default useReasonPolicyRule
